<mat-toolbar color='primary'>
  <span>Prosodik Admin</span>
  <div class="h-spacer"></div>
  <div> <button mat-raised-button (click)="logout()">logout</button> </div>
</mat-toolbar>

<div class='app-container' [class]="[ this.languageService.languageSelected.code ]"   >
  <router-outlet #outlet="outlet" ></router-outlet>
</div>
